var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-row',[_c('app-text',[_vm._v("NP後払いマイページは")]),_c('app-link',{attrs:{"to":_vm.NP_ATOBARAI_MY_PAGE_URL}},[_vm._v("こちら")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }